(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const footerMobileMenuItems = document.querySelectorAll('.footer-mobile-menu-item-title');

    footerMobileMenuItems.forEach((item) => {
      item.addEventListener('click', () => {
        item.parentElement.classList.toggle('footer-mobile-menu-item-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // const menuList = document.querySelector('.header-pc-menu-list');
  const menuItems = document.querySelectorAll('.header-pc-menu-list .header-pc-menu-list-item');
  menuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseover', () => {
      menuItem.classList.add('menu-item-active');
    });

    menuItem.addEventListener('mouseout', () => {
      menuItem.classList.remove('menu-item-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersection) return;

    observer.unobserver(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(productRecommendationSection);

  } catch(e) { console.error(e); }
})();
})();
